// extracted by mini-css-extract-plugin
module.exports = {"invite-link":"index_invite-link_2KKgc","invite-link-text":"index_invite-link-text_3-smu","invite-link-copy":"index_invite-link-copy_3GR2p"};